import {
    SET_ADD_STREAMER,
    SET_REMOVE_STREAMER,
    SET_WIPE_STREAMER
 } from './../../../constants/closeLoop/apmDashboard/streamerConstants';

export const addStreamer = (resource) => (dispatch) => {
    dispatch({type: SET_ADD_STREAMER, payload: resource});
};

export const removeStreamer = (resource) => (dispatch) => {
    dispatch({type: SET_REMOVE_STREAMER, payload: resource});
};

export const removeAllStreamer = () => (dispatch) => {
    dispatch({type: SET_WIPE_STREAMER});
};